import { createStyles } from "@material-ui/core";
export var styles = function (_a) {
    var palette = _a.palette, spacing = _a.spacing;
    return createStyles({
        root: {
            padding: spacing(2),
            textAlign: "center"
        },
        text: {
            color: palette.text.primary,
            fontSmoothing: "antialiased"
        }
    });
};
